<template>
  <div class="interior w100 color-white">
    <div class="page-header">
      <div class="ImageTitle font12" >FOR ILLUSTRATION ONLY</div>
    </div>
    <div class="a98b59-bg color-white relative w100">
      <div class="w60 m-auto p-top-50 p-btm-50 color-f1eee6">
        <h2 class="Initial f500 p-btm-20 lt2 p-top-20 lt5 font25">YOUR DREAM HOME, REIMAGINED.</h2>
        <p class="Initial p-btm-50 font18 regular lh30">
          We’ve lavished each space with efficient layouts and harmonious flow. <br />
          And made room for what’s important to you: flexible design, ample storage and <br />
          quality fittings throughout your luxurious sanctuary.
        </p>
        <div class="w100 relative">
          <!-- swiper -->
          <div class="w100 relative m-auto p-top-50 p-btm-50">
            <swiper
              class="swiper swiperTop bg-525c4e w100"
              :options="swiperInteriorTop"
              ref="swiperInteriorTop"
            >
              <swiper-slide
                class="flex-center"
                v-for="(item, i) in InteriorList"
                :key="i"
              >
                <div class="img-content w100 h100">
                  <img :src="item.path" alt="" />
                  <p style="right: 0" class="color-white">
                    {{ item.name }}
                  </p>
                </div>
              </swiper-slide>
            </swiper>

            <swiper
              class="swiper swiperBtm"
              :options="swiperInteriorBtm"
              ref="swiperInteriorBtm"
            >
              <swiper-slide v-for="(item, i) in InteriorList" :key="i">
                <img
                  class="w100 h100"
                  style="object-fit: cover"
                  ondragstart="return false;"
                  :src="item.path"
                  alt=""
                  @click="handleSlideClick(i)"
                />
              </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" style="left: -15%; top: 45%">
              <img src="@/assets/btn/left2.png" alt="" />
            </div>
            <div class="swiper-button-next" style="right: -15%; top: 45%">
              <img src="@/assets/btn/right2.png" alt="" />
            </div>
          </div>

          <h2 class="lt2 medium">BUILT FOR MORE</h2>
          <p class="Initial font14 regular lh25">
            Dreams are made of these—master bedrooms designed to comfortably fit a King bed, and in other bedrooms, a Queen bed. <br />
            To maximise storage, all bedrooms come with full-height wardrobes. And to imbue the kitchen with added luxury, <br />
            each comes fully equipped with kitchenware from the Küche Collection, inspired by German quality and function. <br />
            Bathrooms are well-appointed too, with good storage and quality fittings from Bravat and Hansgrohe.
          </p>
        </div>
      </div>
    </div>
    <div class="interior-bg1 flex-center title-bg-text">
      <p class="Initial a98b59-color light font48">LIVE GREEN, NATURALLY.</p>
    </div>
    <div class="w100 relative bg-525c4e">
      <div class="w60 m-auto">
        <p class="Initial regular lh30 medium font18 p-top-90">
          Making sustainable choices is second nature when you care about the
          environment and people. Which is why the developers take great pride
          in building homes that strive to meet the environmental standards to
          achieve BCA’s prestigious Green Mark Platinum Super Low Energy
          certification.
        </p>
        <div class="w100 flex-row space-between m-top-20 p-btm-50 interior-list">
          <div class="w45 flex-column items-start">
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR1.png"
                  alt=""
                />
              </div>

              <div
                class="flex-column items-start text-h-75"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  EV-CHARGING STATIONS
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  EV-charging lots will be provided in the car park, making it
                  easy for EV car owners to live greener.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR3.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SOLAR-SUPPLEMENTED
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Solar Photovoltaic (PV) systems on rooftops will provide
                  renewable energy for 30% of the electrical consumption at
                  common facilities.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR5.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  E-WASTE BINS
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  E-waste bins provided will help reduce the amount going to
                  landfills, promote circularity and keep materials in use for
                  longer.
                </div>
              </div>
            </div>
          </div>

          <div class="w45 flex-column items-start">
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR2.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  CAR SHARING SERVICE
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Enjoy sheer convenience with access to car rental via the car
                  sharing service*
                </div>
                <div class="w100 lh25 color-f1eee6 font12 textStarts light">
                  *Terms and conditions apply.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR4.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  ENERGY EFFICIENCY
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Most efficient 5-tick rated air-conditioning systems will be
                  used to bring energy consumption to a minimum.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR6.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SAFE CERTIFICATION
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Material finishes with low Volatile Organic Compound (VOC)
                  emissions will be used for the development to ensure
                  residents’ health and well-being
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="interior-bg2 flex-center title-bg-text" >
      <p class="Initial a98b59-color light font48">LIVE SMART, SEAMLESSLY.</p>
    </div>
    <div class="w100 relative bg-51596f">
      <div class="w60 m-auto">
        <p class="Initial p-top-50 lh30 medium font18 p-top-90">
          Smart features are a great help at home. They let you perform multiple
          tasks from wherever you are. Like answering the door, turning the
          air-con on, or changing the safety setting on kitchen appliances, even
          when you’re miles from home.
        </p>
        <div class="w100 flex-row space-between m-top-20 p-btm-50 interior-list">
          <div class="w45 flex-column items-start">
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR7.png"
                  alt=""
                />
              </div>

              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SMART DOORBELL
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Answer the door with your phone, see and talk to visitors from
                  wherever you are.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR9.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SMART AIR-CON
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Cool your apartment remotely for the perfect welcome home.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR11.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SMART BOOKING
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Check on the availability of facilities and book via a mobile
                  app
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR13.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium" style="text-align: start;">
                  SMART KITCHEN APPLIANCES
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Smart kitchen solutions with safety features controllable via
                  your smartphone makes cooking simpler and safer.
                </div>
              </div>
            </div>
          </div>

          <div class="w45 flex-column items-start">
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR8.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">SMART LOCK</h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Enjoy enhanced accessibility for loved ones with different
                  ways to lock and unlock your main door
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR10.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SMART GATEWAY
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Conveniently control all your smart devices via the smart home
                  app on your mobile.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR12.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SMART INVITE
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Give guests easy entry to your gatherings via quick access QR
                  codes.
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 p-top-50">
              <div class="left-logo flex-center">
                <img
                  class="img-initial"
                  src="@/assets/btn/INTERIOR14.png"
                  alt=""
                />
              </div>
              <div
                class="flex-column items-start text-h-75"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial font18 a98b59-color lt2 medium">
                  SMART PARCEL BOXES
                </h4>
                <div class="w100 lh25 color-f1eee6 font14 textStarts light">
                  Do away with scheduling your deliveries when you send them
                  directly to the smart parcel boxes so you can collect them at
                  your own time.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="floorplans bg-f7f6f6 w100 p-btm-50">
      <h2 class="Initial font48 light lt2 a98b59-color p-top-50 p-btm-50">
        UNIT DISTRIBUTION CHART
      </h2>
      <!-- <div class="w80 m-auto">
        <img class="img-initial" src="@/assets/interior/floorplan.png" alt="" />
      </div> -->
      <div class="BuildingData m-auto w60">
      <div class="BuildingShowDiv"  v-for="(building, a) in BuildingList" :key="a">
        <div class="BuildingTitle">{{ building.title }}</div>
        <div class="table-data">
          <div
            class="table-tr"
            v-for="(data, tr) in building.buildingData"
            :key="tr"
            :class="{ mergetr: data.length == 2 }"
          >
            <div
              class="table-td font12"
              :style="`background-color:${tddata.color};`"
              :class="{'td-tab': td == 0,'td-tab-top': td != 0 && tr == 0, mergetd: td == 1 && data.length == 2}"
              @click="goUnit(tddata.unitname)"
              v-for="(tddata, td) in data"
              :key="td"
              v-if="tddata.show || tddata.type == 'tab' || tddata.type == 'Stacks'"
            >
              <span v-if="tr !=0 && td == 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td != 0">{{ tddata.name }}</span>
              <span v-else-if="tr == 0 && td == 0">{{ tddata.name }}</span>
              <span v-else >{{ tddata.name }}</span>
            </div>
            <div v-else class="table-td" 
            :class="{'td-tab': td == 0,'td-tab-top': td != 0 && tr == 0, mergetd: td == 1 && data.length == 2}"
            ></div>
          </div>
        </div>
      </div>
      <div class="BuildingShowDiv color-black p-top-50">
        <div class="textStarts f500 LEGEND w100">LEGEND</div>

        <div class="flex-row" style="flex-wrap: wrap;">
          <div class="flex-column items-start w50">
            <p class="f500 font12">3-BEDROOM</p>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #d5dbbf;"></div>
              <div>TYPE C1</div>
            </div>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #d5dbbf;"></div>
              <div>TYPE C1-G</div>
            </div>
          </div>
          <div class="flex-column items-start w50">
            <p class="f500 font12">4-BEDROOM</p>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #dbc9c4;"></div>
              <div>TYPE D1</div>
            </div>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #dbc9c4;"></div>
              <div>TYPE D1-G</div>
            </div>
          </div>
          <div class="flex-column items-start w50">
            <p class="f500 font12">3-BEDROOM + STUDY</p>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #e3cdb3"></div>
              <div>TYPE C2</div>
            </div>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #e3cdb3"></div>
              <div>TYPE C2-G</div>
            </div>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #c0d4ca"></div>
              <div>TYPE C3</div>
            </div>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #c0d4ca"></div>
              <div>TYPE C3-G</div>
            </div>
          </div>
          <div class="flex-column items-start w50">
            <p class="f500 font12">4-BEDROOM + STUDY</p>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #e5dab0"></div>
              <div>TYPE D2</div>
            </div>
            <div class="flex-row m-btm-5 font10">
              <div class="floorType" style="background-color: #e5dab0"></div>
              <div>TYPE D2-G</div>
            </div>
          </div>
          <div>
            <img class="img-initial" src="@/assets/interior/floorplan-btm-logo.png" alt="">
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="w100 relative bg-575252 p-btm-90">

      <h2 class="Initial font48 light a98b59-color p-top-50 p-btm-50">
        TAKE A VIRTUAL TOUR
      </h2>
      <div class="w60 m-auto relative" style="z-index: 100;">
        <div
          class="flex-row w100 flex-row content-around cursor-pointer"
        >
          <div class="flex1 font16" 
          v-for="(item, index) in vrList" 
          :key="index" 
          @click="vrIndex = item"
          :class="{ TabIndex: vrIndex.name == item.name }" style="color: white;">
            {{ item.name }}
          </div>
        </div>
        <div style="width: 100%; height: 60vh">
          <iframe class="w100 h100" :src="vrIndex.path" frameborder="0" ></iframe>
        </div>
      </div>
      <img
      class="w100"
      style="position: absolute; bottom: 15%;left: 0;z-index: 10;"
      src="@/assets/btn/line5.png"
      alt=""
    />
    </div>
    <div v-if="UnitPopType" class="unit-pop fixed w100 h100 flex-center color-black" style="top: 0;left: 0;z-index: 1200;">
      <div class="w100 h100 pop-info p-btm-50" style="overflow: auto;background-color: white">
        <div class="flex-row space-between m-auto items-center p-top-120" style="height: 10%;">
          <div style="display: flex;">
            <div class="triangle" :style="`border-top:100px solid ${nowUnit.color};`"></div>
            <h2>{{ nowUnit.type }}</h2>
          </div>
          <!-- <img style="margin: 10px;height: 80%;" src="@/assets/btn/logo.png" alt=""> -->
          <img @click="UnitPopType = false" style="margin-right: 20px;" width="25px" height="25px" src="@/assets/208/close.png" alt="">
        </div>
        <div class="w100 unit-img-group">
          <img  class="img-initial m-auto unit-img" :src="nowUnit.plan" alt="">
        </div>
        <img style="margin: 10px;height: 80%;position: absolute;bottom: 10px;right: 10px;width: 120px;height: auto;" src="@/assets/btn/logo.png" alt="">
      </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      vrIndex:{name:"3-BEDROOM + STUDY",path:"https://my.matterport.com/show/?m=q2hGn3X7XLw"},
      vrList:[
        {name:"3-BEDROOM + STUDY",path:"https://my.matterport.com/show/?m=q2hGn3X7XLw"},
        {name:"4-BEDROOM + STUDY",path:"https://my.matterport.com/show/?m=ThVSLGUH2HX"},
      ],
      InteriorList:[
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Living Room_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Bedroom Flexi_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Kitchen_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_PD Door_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Bedroom_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Wardrobe_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Bathroom_RGB_lr.jpg"),},
      {name: "FOR ILLUSTRATION ONLY",path: require("@/assets/interior/_Novo Show Unit_Bathroom2_RGB_lr.jpg"),},
      ],
      swiperInteriorBtm: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 10,
        loopedSlides: 5, // looped slides should be the same
        loop:true,
        // touchRatio: 0.2,
        spaceBetween: 10,
        centeredSlides: true,
        // direction: 'vertical',
      },
      swiperInteriorTop: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        loopedSlides: 5, // looped slides should be the same
        // spaceBetween: 10,
        centeredSlides: true,
        loop:true,
        // autoplay: {
        //     delay: 3000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      nowUnit:{},
      UnitPopType: false,
      // 楼栋列表
      BuildingList: this.$Datas.building,
      // 户型列表
      FloorplanData:this.$Datas.floorplan,
      UnitTypeLists:this.$Datas.unit_type_list,
    };
  },
  methods: {

    goUnit(items){
      
      this.nowUnit = this.FloorplanData[items]
      this.UnitPopType = true
    },
    handleSlideClick(index) {
      // 切换到指定索引的 slide
      console.log(index);
      this.$refs.swiperInteriorBtm.swiper.slideTo(index);
    },
  },
  mounted() {
    this.$nextTick(() => {
      const top = this.$refs.swiperInteriorTop.swiper;
      const bottom = this.$refs.swiperInteriorBtm.swiper;
      top.controller.control = bottom;
      bottom.controller.control = top;
    });
  },
};
</script>

<style lang="less">
.left-logo {
  width: 75px;
  height: 50px;
  margin-right: 20px;
  margin-bottom: 20px;
}

.LEGEND{
    position: relative;
    padding: 10px 0;
  }
.LEGEND::before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #616161
};
.LEGEND::after{
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #616161
};
.BuildingTitle{
    margin-bottom: 1rem;
    color: black;
    font-weight: 600;
    text-align: start;
    margin-left: 20%;
  }
.interior {
  margin-top: -56px;
  .text-h-75{
    width: calc(100% - 45px);
    height: 95px;
  }
  .triangle {
    width: 0;
    height: 0;
    border-left: 0px solid transparent;
    border-right: 100px solid transparent;
    border-top: 100px solid blue;
  }
  .title-bg-text{
    height: 20vh;

  }
  .BuildingShowDiv:nth-child(2),.BuildingShowDiv:nth-child(3),.BuildingShowDiv:nth-child(5),.BuildingShowDiv:nth-child(6),.BuildingShowDiv:nth-child(8){
    width: calc(25% - 90px);
    margin-left: 95px;
    .td-tab{
    display: none;
  }
  .BuildingTitle{
    margin-left: 0;
  }
  }
  .floorType{
    width: 20px;
    height: 16px;
    margin-right: 10px;
  }

  .page-header {
    height: calc(100vh - 110px);
    background-image: url("~@/assets/interior/_Novo Show Unit_Living Room_RGB_lr.jpg");
    background-size: cover;
    background-position-y: 78%;
    position: relative;
  }
  .interior-bg1 {
    background-image: url("~@/assets/interior/interior25.png");
    background-size: cover;
  }
  .interior-bg2 {
    background-image: url("~@/assets/interior/interior26.png");
    background-size: cover;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 2rem;
      max-width: 2rem;
    }
  }
  .swiperTop{
    height: 75vh;
  }
  .swiperBtm {
    height: 75px;
    padding-bottom: 15px;
    padding-top: 10px;
  }
  .swiperBtm .swiper-slide {
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
  .swiperBtm .swiper-slide-active {
    position: relative;
    opacity: 1;
  }
  .swiperBtm .swiper-slide-active::before {
    position: absolute;
    left: 0;
    bottom: -8px;
    content: "";
    background-color: #a98b59;
    width: 100%;
    height: 5px;
  }
  .BuildingData {
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .BuildingShowDiv {
    // position: absolute;
    width: 25%;
    // height: calc(100% - 2vh);
    // height: 85%;
    margin: 0 3%;
    // margin-bottom: 5vh;
    margin-top: 2vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .mergetr {
  position: relative;
  width: 100%;
}
.mergetd {
  // position: absolute;
  width: calc(100% - 65px) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  border: 0 !important;
  border-bottom: 1px solid #000000 !important;

  // margin: auto;
}
.table-data {
  border-collapse: collapse;
  border-spacing: 0;
  // border: 1px solid #80808054;
  // font-family: QuicksandBook;
  width: 99%;
  color: #000;
  // margin-top: 3rem;
  // margin-bottom: 2.5rem;
  display: table;
}
.table-tr {
  // border: 1px solid #9E9E9E;
  display: flex;
  flex-direction: row;
  // width: 99%;
}
.td-tab {
  // width: 1.5rem !important;
  // border: 0 !important;
  border: 1px solid #ffffff00 !important;
  // font-weight: 600 !important;
  // font-size: 14px !important;
  // background-color: #000 !important;
}
.td-tab-top{
  // font-weight: 600 !important;
  // font-size: 14px !important;
  // border:  0px solid #000000 !important;
  border: 0px !important;
  border-top: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
  // background-color: white !important;
}

.table-td:hover {
  color: #ffffff !important;
  background-color: #616161 !important;
}
.table-td {
  height: 16px;
  cursor: pointer;
  // border-bottom: 1px solid #000000;
  font-size: 12px;
  // font-weight: 400 !important;
  text-align: center;
  width: 75px;
  // width: 25%;

  // border: 1px solid #9E9E9E;
  border-width: 0 0 0 1px;
  margin: 0;
  overflow: visible;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 1rem;
  border-collapse: collapse;
  // background-color: #0000;
  border: 1px solid #000000;
  margin: -1px;
}

.unit-img-group{
  // height: calc(90% - 120px);
  // overflow: auto;
  .unit-img{
    width: 90%;
    max-height: none;
}

}



}

@media (max-width: 900px) {

  .interior{
    .title-bg-text{
      height: 8vh;
      .font48{
        font-size: 24px;
      }
    }
    .BuildingShowDiv:nth-child(2),.BuildingShowDiv:nth-child(3),.BuildingShowDiv:nth-child(5),.BuildingShowDiv:nth-child(6){
      width: 25%;
      margin-left: 3%;
    .td-tab{
      display: block;
    }
    .BuildingTitle{
      margin-left: 20%;
    }
    }
    .BuildingShowDiv:nth-child(8){
      margin-left: 3%;
    }
    .unit-img-group{
      height: 85%;
      margin-top: 5%;
    }


    .page-header{
      height: 30vh;
    }
    .swiperTop{
    height: 45vh;
  }
  .swiperBtm {
    height: 25px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .swiper-button-prev,
  .swiper-button-next{
    display: none;
  }
  .interior-list{
    flex-direction: column !important;
    .items-start{
      width: 100% !important;
      h4{
        text-align: start;
      }
      //   .flex-row .items-start{
      //     width: calc(100% - 95px) !important;

      // }
    }
  }

  .BuildingShowDiv{
    width: 100% !important;
  }
  .table-td {
  width: 25%;

  }
  .pop-info{
    width: 100% !important;
    height: 100% !important;
  }
  }




}






</style>











